export const environment = {
  //SSO APIs
  SSOauthAPI: "https://qapi.auth.myzpax.com/api",
  ssoUserInfoAPI: "https://qapi.auth.myzpax.com/connect/userinfo",
  ssoConnectAPI: "https://qapi.auth.myzpax.com/connect/authorize",
  ssoLogoutAPI: "https://qapi.auth.myzpax.com/api/account/logout",
  ssoLoginUrl: "https://qa.auth.myzpax.com/sso/login",

  zpaxEsignatureDocumentRedirectEndPoint: "https://qa.myzpax.com/app/document-signature/documents",
  zpaxChangepasswordEndpoint:"https://qa.myzpax.com/user/password-and-security",
  zpaxPrivacyPolicyEndPoint: "https://qa.myzpax.com/privacy.html",
  zpaxTermsEndPoint: "https://qa.myzpax.com/terms.html",


  endpoint: "https://qapi.zrehabconnect.com/api/v1",
  sessionEncryptionKey:
    "fCCmUMuOM0kuDCuLe7naPOo6sNvlhXshFhZEVomw5XAS9vR7M0YGxbeaeYhiNmOC",
  idleTimeBeforeLocking: 1800,
  idleTimeBeforeTerminating: 2400,
  clientId: "fgyw5yplofcg65uwwxeomxrzcnwa3huw",
  userDetailsAPI: "/user/get",
  authorizationAPI: "/authorization",
  AWS_REGION: "us-east-1",
  AWS_ACCESS_KEY_ID: "",
  AWS_SECRET_ACCESS_KEY: "",
  AWS_SESSION_TOKEN: "",
  biDashboardSupersetDomain : 'https://4df6a8e3.us2a.app.preset.io',

  /**Matomo Analytics*/
  enableMatomo: false,
  matomo: {
    trackerUrl: "https://sandbox.matomo.z-pax.com/",
    siteId: 4
  },

  /**Pagesense */
  enablePagesense: true,
  pagesenseUrl: "https://cdn.pagesense.io/js/rehabconnectllc/b4f58c20f6384385a840cbf314bb6653.js",

  growthbook: {
    apiHost: "https://api.rc-feature-flag-dev-qa.zrehabconnect.com",
    clientKey: "sdk-0qGw9UIJ4xGVWKGi",
    enableDevMode: false
  },

  enableNewReactApp: false,
  postMessageTargets: ['https://qa.myzpax.com'],
  supportEmail: 'support@rehabconnect.com',

  /** CMI Connect Therapy Referrals iframe */
  therapyReferralUrl: "",
  therapyReferralFullAppUrl: "",
};
